import {Component, OnInit} from '@angular/core';
import {AppointmentModel} from "../../../core/models/appointment.model";
import {ActivatedRoute, Router} from "@angular/router";
import {TranslateModule} from "@ngx-translate/core";
import {MatButton} from '@angular/material/button';
import {MatCard, MatCardContent} from '@angular/material/card';
import {HeadlineTextComponent} from "../../../shared/components/headline-text/headline-text.component";
import {FeedbackFormDeclinedComponent} from "../../components/feedback-form-declined/feedback-form-declined.component";
import {PreventDoubleClickDirective} from "../../../shared/directives/prevent-doublic-click-directive";
import {NavigationService} from "../../../core/services/navigation.service";
import {AppointmentService} from "../../services/appointment.service";
import {UrlTreeHelper} from "../../../core/services/url-tree-helper";
import {CommentModel} from "../../../core/models/comment.model";
import {FormGroup} from "@angular/forms";
import {TestRunService} from "../../services/test-run.service";
import {GtmEventDirective} from "../../../shared/directives/gtm-event.directive";

@Component({
  selector: 'declined-no-timeslot-lookup',
  templateUrl: './declined-no-timeslot-lookup.component.html',
  styleUrls: ['./declined-no-timeslot-lookup.component.scss'],
  standalone: true,
  imports: [MatCard, TranslateModule, HeadlineTextComponent, FeedbackFormDeclinedComponent, MatButton, PreventDoubleClickDirective, MatCardContent, GtmEventDirective]
})
export class DeclinedNoTimeslotLookupComponent implements OnInit {
  public appointment!: AppointmentModel;
  public formValid: boolean = false;
  protected comment!: CommentModel;
  private isTestRun!: boolean;

  constructor(
    private route: ActivatedRoute,
    private navigation: NavigationService,
    private appointmentService: AppointmentService,
    private router: Router,
    private urlTreeHelper: UrlTreeHelper,
    private testRunService: TestRunService) {
    this.isTestRun = this.testRunService.isTestRun();
  }

  ngOnInit() {
    this.appointment = this.route.snapshot.data['appointment'];
  }

  back(): void {
    this.navigation.back();
  }

  handleFeedbackForm(feedbackForm: FormGroup): void {
    this.formValid = feedbackForm.valid;
  }

  receiveOutput(comment: CommentModel): void {
    this.comment = comment;
  }

  send() {
    const BASE_PATH = '/' + this.route.snapshot.params['factoryId'] + '/' + this.route.snapshot.params['language'] + '/' + this.route.snapshot.params['id'];
    this.appointmentService
      .addComment(this.appointment, this.comment, this.isTestRun)
      .subscribe(data => {
        this.router.navigateByUrl(this.urlTreeHelper.generateUrlTree(
          BASE_PATH, {suffix: 'message-received'}), {state: this.comment});
      });
  }
}
